import { api } from 'app/utils/api/helpers'

export const deleteTeamMember = (teamGUID, payload) => {
  return api.delete(`/sm/team/${teamGUID}/deleteteammember`, payload)
}

export const getTeamMembersList = (agencyGUID) => {
  return api.get(`/sm/teams/${agencyGUID}/preferences/members`)
}

export const updateTeamMember = (teamGUID, teamMemberGUID, payload) => {
  return api.put(`/sm/team/${teamGUID}/members/${teamMemberGUID}`, payload)
}
